import React, { useEffect, useState } from "react";
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';

import ProfileMain from "../profile/ProfileMain";
import DefaultLoader from "../../components/loader/DefaultLoader";
import NextSeriesMain from "../profile/NextSeriesMain";
import RecentGameMain from "../profile/RecentGameMain";
import TrackmanChartMain from "../record/TrackmanChartMain";
import PitchLocationMain from "../record/PitchLocationMain";
import DamageChartMain from "../record/DamageChartMain";
import MovingChartMain from "../record/MovingChartMain";
import PitchDistributionChartMain from "../record/PitchDistributionChartMain";
import PitcherRecordTableMain from "../record/PitcherRecordTableMain";
import LocationResultMain from "../record/LocationResultMain";
import MovementProfile from "../profile/MovementProfileMain";

function MinorLeaguePitcherArea({profile}) {
    const style={
        height: '450px',
        display: 'flex',
        flexDirection: 'column'
    }

    return (
        <>
        <Row>
            <Col md={3} className="digestDivBox" id="playerProfile">
                {
                    profile['teamId'] ?
                    <ProfileMain profile={profile} leagueType={4206}/> :
                    <div style={{...style, ...{height:'390px'}}}>
                        <DefaultLoader/>
                    </div>
                }
            </Col>
            <Col id="gameSchedule" className="digestDivBox">
                {
                    profile['teamId'] ?
                    <MovementProfile profile={profile} leagueTypeCodes={'KBOFutures'}/> :
                    <div style={{...style, ...{height:'390px'}}}>
                        <DefaultLoader/>
                    </div>
                }
            </Col>
            <Col id="last7games" className="digestDivBox">
                {
                    profile['teamId'] ?
                    <RecentGameMain profile={profile} leagueType={4206}/> :
                    <div style={{...style, ...{height:'390px'}}}>
                        <DefaultLoader/>
                    </div>
                }
            </Col>
        </Row>
        <Row>
            <Col id="chartZone1" className="digestDivBox" style={{position:'relative', height: '500px'}}>
                <div style={style}>
                {
                    profile['teamId'] ?
                    <TrackmanChartMain profile={profile} leagueType={4206}/> :
                    <DefaultLoader/>
                }
                </div>
            </Col>
            <Col id="chartZone2" className="digestDivBox" style={{position:'relative', height: '500px'}}>
                <div style={{...style, ...{textAlign:'center'}}}>
                {
                    profile['teamId'] ?
                    <LocationResultMain profile={profile} leagueType={4206}/> :
                    <DefaultLoader/>
                }
                </div>
            </Col>
            {/* <Col id="chartZone1" className="digestDivBox" style={{position:'relative', height: '500px'}}>
                <div style={{...style, ...{textAlign:'center'}}}>
                {
                    profile['teamId'] ?
                    <PitchDistributionChartMain profile={profile} /> :
                    <DefaultLoader/>
                }
                </div>
            </Col> */}
        </Row>
        <Row>
            <Col id="movingChartZone" className="digestDivBox" style={{position:'relative'}}>
                {
                    profile['teamId'] ?
                    <MovingChartMain profile={profile} leagueType={4206}/> :
                    <DefaultLoader/>
                }
            </Col>
        </Row>
        <Row>
            <Col id="damageMap" className="digestDivBox2" style={{position:'relative', minWidth: '100%'}}>
            {
                profile['teamId'] ?
                <DamageChartMain profile={profile} leagueType={4206}/> :
                <DefaultLoader/>
            }
            </Col>
            <Col id="pitchLocation" className="digestDivBox2" style={{position:'relative', minWidth: '100%'}}>
            {
                profile['teamId'] ?
                <PitchLocationMain profile={profile} leagueType={4206}/> :
                <DefaultLoader/>
            }
            </Col>
        </Row>
        <Row>
            <div id="tableContainer">
            {
                profile['teamId'] ?
                <PitcherRecordTableMain profile={profile}/> :
                <div style={{height: '200px'}}>
                    <DefaultLoader/>
                </div>
            }
            </div>
        </Row>
        </>
    )
}

export default MinorLeaguePitcherArea;